export default "__VITE_ASSET__ftE7FU1N__"